/* Accordion button */
var $closestAccordion = $(this).closest('.accordion')
var id = $closestAccordion.attr('id');

$('.collapse').on('hidden.bs.collapse', function () {

  $('.expandAll[data-target="#'+id+'"]').removeClass('disabled');

  // If all items are hidden then disable the collapse link 
  if ($closestAccordion.find('.collapse.show').length == 0){
    $('.collapseAll[data-target="#'+id+'"]').addClass('disabled');
  }
})

$('.collapse').on('shown.bs.collapse', function () {

  $('.collapseAll[data-target="#'+id+'"]').removeClass('disabled');

  // If all items are shown then disable the expand link
  if ($closestAccordion.find('.collapse:not(.show)').length == 0){
    $('.expandAll[data-target="#'+id+'"]').addClass('disabled');
  }

})

$('.expandAll').click(function() {
  // Disable the expand all link
  var id = $(this).attr('data-target');
  $(this).addClass('disabled');

  // Enable the collapse all link
  $('.collapseAll[data-target="'+id+'"]').removeClass('disabled');

  // Show all items
  $(id + ' .collapse').collapse('show');
})

$('.collapseAll').click(function() {
  // Disable the collapse all link
  var id = $(this).attr('data-target');
  $(this).addClass('disabled');

  // Enable the expand all link
  $('.expandAll[data-target="'+id+'"]').removeClass('disabled');

  // Hide all items
  $(id + ' .collapse').collapse('hide');
})

// allow hashtags to target and open accordions
function openAccordionWithAnchor(hash) {
  var targetAccordion = $(hash).closest('.collapse')

  // If anchor is inside an accordion then scroll to the panel
  if (targetAccordion.length){
    targetAccordion.collapse('show');

    $('html, body').delay(500).animate({
      scrollTop: $(hash).offset().top - 50
    }, 50);
  }
}

// opens accordion on page load that has an anchor in the URL
if (window.location.hash != "") {
  openAccordionWithAnchor(window.location.hash); 
}

// open accordion with an anchor whenever an anchor is clicked    
$('a[href*="#"').on('click', function(event) {
  openAccordionWithAnchor(event.target.hash);
})
